import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-site-nav-bar',
  templateUrl: './site-nav-bar.component.html',
  styleUrls: ['./site-nav-bar.component.scss']
})
export class SiteNavBarComponent implements OnInit {
  public searchForm: FormGroup;
  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      search: ['']
    })
  }

}
